import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 异步加载路由
const asyncComponent = pathName => {
  return resolve => {
    import(`@/pages/${pathName}`).then(component => {
      resolve(component)
    })
  }
}

const routes = [
  {
    path: '/',
    component: asyncComponent('krpano')
  }
]

const router = new VueRouter({
  routes
})

export default router
